import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import { BoilerPart } from './tree.interface';

//FIX ME export to a enum class
export enum BoilerActorType {
  CONNECTOR = 'connections',
  HEAT_EXCHANGER = 'heatExchangers',
  CYLINDER = 'cylinder',
  AXES = 'axes',
  PATCH = 'patch',
  FLANGE = 'flange',
}

export interface Data {
  value: number;
  unit: string;
}

export interface BoilerActor {
  id: number;
  actor: vtkActor;
  type: BoilerPart;
}

export interface HeatExchanger {
  name?: Name;
  type?: Head;
  power?: Height;
  comment?: Name;
  endHeight: Height;
  startHeight: Height;
}

export interface Connection {
  name?: Name;
  type: Type;
  height: Height;
  comment?: string;
  material?: Head;
  tubeLength: TubeLength;
  innerDiameter: Height;
  flangeThickness: FlangeThickness;
  tubeWallThickness?: Height;
  insulationMaterial?: InsulationMaterial;
  flangeOuterDiameter: Height;
  insulationThickness?: InsulationThickness;
  displayAngle: DisplayAngle;
  location: Value;
  orientation: Value;
}

export interface CamPos {
  x: number;
  y: number;
  z: number;
}

export interface GeoBoiler {
  height: number;
  diameter: number;
  thickness: number;
  connections: Connection[];
  heatExchangers: HeatExchanger[];
  patches: Patches[];
  camPos: CamPos;
  radius: number;
  nCells: number;
}

// input Value
export interface Inputvalue {
  tank: Tank;
  filling: Filling;
  patches: Patches[];
  insulation: Insulation;
  simulation: Simulation;
  connections: Connection[];
  heatExchangers: HeatExchanger[];
}

interface Value {
  value: string;
}

interface Type {
  value: string;
  options: Value[];
}

interface InsulationThickness {
  unit: string;
  value: number;
  ifType: string;
}

interface InsulationMaterial {
  ifType?: string;
  default?: string;
  options?: string[];
  value?: string;
}

interface FlangeThickness {
  unit?: string;
  value: number;
}

interface TubeLength {
  unit: string;
  value: number;
  optional: boolean;
}

interface Simulation {
  norm: Head;
  nCells: Height;
  convection: Head;
  alphaInside: Height;
  alphaOutside: Height;
  ambientMaterial: Head;
  measurementTime: Height;
  samplingInterval: Height;
  startTemperature: StartTemperature;
  ambientTemperature: StartTemperature;
}

interface StartTemperature {
  value: number;
}

interface Insulation {
  comment: string;
  material: Head;
  thickness: Height;
}

export enum Orientation {
  AXIAL = 'axial',
  RADIAL = 'radial',
}

export enum Location {
  TOP = 'top',
  BOTTOM = 'bottom',
}

interface Option {
  id: string;
  value: string;
}

interface Material {
  value: string;
  options: Option[];
}

export interface Layer {
  title: string;
  material: Material;
  thickness: Height;
}

export interface Patches {
  area: Height;
  name?: Name;
  heightMin: Height;
  heightMax: Height;
  location: Value;
  material?: Head;
  // thickness: Height;
  orientation: Value;
  comment?: Name;
  displayAngle: DisplayAngle;
  layer: Layer[];
}

export interface PartOrientation {
  orientation: Orientation;
  location?: Location;
}

// export type BoilerObjects = Patches | Tank | Connection | Simulation | Filling | Insulation;

// interface Location {
//   ifType: string;
//   default: string;
//   options: string[];
// }

// interface Height2 {
//   value: number;
//   ifType: string;
// }

interface Name {
  value: string;
}

interface Filling {
  material: Head;
}

interface Tank {
  head: Head;
  bottom: Head;
  height: Height;
  diameter: Height;
  material: Head;
  materialHull: Head;
  innerWallThickness: Height;
  outerWallThickness: Height;
}

interface Height {
  unit: string;
  value: number;
}

interface DisplayAngle {
  value: number;
}

interface Head {
  default: string;
  options: string[];
}
